import { CoreMenu } from 'src/@core/types';

export const employeeUtilsMenu: CoreMenu[] = [
  {
    id: 'Employee-Types',
    title: 'Employee Type',
    type: 'item',
    icon: 'types.svg',
    url: '/setup/employee-setup/types',
    role: {
      roles: ['employee'],
      right: 'L1032',
    },
  },
  {
    id: 'Employee-Categories',
    title: 'Employee Category',
    type: 'item',
    icon: 'employee-categories.svg',
    url: '/setup/employee-setup/categories',
    role: {
      roles: ['employee'],
      right: 'L1024',
    },
  },
  {
    id: 'Employee-Grades',
    title: 'Employee Grade',
    type: 'item',
    icon: 'grade.svg',
    url: '/setup/employee-setup/grades',
    role: {
      roles: ['employee'],
      right: 'L1028',
    },
  },
];
